export default __webpack_public_path__ + "static/tag-dont-4-light-3f4fc432a94c6c51813e104537c0588629737f1d73eb49830f860050d1a4f2cf.png";